import React from 'react';
import {MainLayoutWebFormPage} from "../../platform/webform/WebFormPages";
import {createInternationalizationPrefixer} from "../../platform/i18n/i18n";
import {SmtpTrialForm} from "./SmtpTrialForm";

const t = createInternationalizationPrefixer("TestEmailPage");

export function TestEmailPage() {
    return <>
        <MainLayoutWebFormPage
            title={t("Wyślij testowy e-mail")}
            submitLabel={t("Wyślij")}
            dslUrl="/api/admin/test-email/form"
            submissionUrl="/api/admin/test-email/submit"
            successHandler={() => alert(t("E-mail wysłany (lub przechwycony w trybie in-memory)."))}/>
        <SmtpTrialForm/>
    </>;
}
